<template>
  <el-dialog :visible="visible" width="800px" @close="close" title="用户详情" custom-class="customModal">
    <div class="container">
      <el-image class="img" :src="userData.head_pic"></el-image>
      <div class="content">
        <div class="field">编号：{{userData.number}}</div>
        <div class="field">用户名：{{userData.username}}</div>
        <div class="field">昵称：{{userData.nickname}}</div>
        <div class="field">手机号：{{userData.tel_phone}}</div>
        <div class="field">邮箱：{{userData.email}}</div>
        <div class="field">qq：{{userData.qq}}</div>
        <div class="field">会员等级：{{userData.level}}</div>
        <div class="field">会员积分：{{userData.pay_point}}</div>
        <div class="field">注册时间：{{userData.reg_time}}</div>
        <div class="field">最后登录时间：{{userData.last_time}}</div>
        <div class="field">账号状态：{{userData.status}}</div>
      </div>
    </div>
    <AppButton type="primary" @click="close" size="small">关闭</AppButton>
  </el-dialog>
</template>

<script>
  export default {
    name: 'userDetailModal',
    data() {
      return {
        visible: false,
        userData: {},
      }
    },
    methods: {
      open(userData) {
        this.userData = userData;
        this.visible = true;
      },
      close() {
        this.visible = false;
      }
    }
  }
</script>

<style lang="scss" scoped>

.container {
  width: 100%;
  // display: flex;
  display: inline-block;
  .img {
    width: 100px;
    height: 100px;
    margin-right: 20px;
    float: left;
  }
  .content {
    width: 700px;
    .field {
      float: left;
      text-align: left;
      margin-left: 18px;
      width: 25%;
    }
  }
}
</style>